import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import { GuardProps } from 'types';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }: GuardProps) => {
    const { isLoggedIn, isInitialized } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!isLoggedIn && !isInitialized) {
            navigate('/login', { replace: true });
        }
    }, [isLoggedIn, isInitialized, navigate]);

    return children;
};

export default AuthGuard;
